import { createFeatureSelector, createSelector } from '@ngrx/store';
import { titleFeatureKey, TitleState } from './title.reducer';

export const getTitleFeature = createFeatureSelector<TitleState>(titleFeatureKey);

export const getTitle = createSelector(getTitleFeature, (state) => state.title);
export const getTitleSecondary = createSelector(getTitleFeature, (state) => state.title_secondary);
export const getTitleThird = createSelector(getTitleFeature, (state) => state.title_third);